import styled, { space, css, themeGet, SpaceProps } from "../../../shared/styled";

export const StyledNav = styled.nav``;

export const StyledBreadcrumb = styled(({ mr, ml, mb, mt, ...props }) => (
    <ol {...props} />
))<SpaceProps>`
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin-bottom: 10px;
    margin-top: 0;
    list-style: none;
    border-radius: 0.25rem;
    ${(props) =>
        props.theme.name === "dark" &&
        css`
            background-color: transparent;
        `}
    ${space};
`;

interface IProps {
    $active?: boolean;
}

export const StyledBreadcrumbItem = styled.li<IProps>`
    font-family: 'SF Pro Text';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #6B778C;
    
    ${({ $active }) =>
        $active &&
        css`
            color: #6B778C;
            ${(props) =>
                props.theme.name === "dark" &&
                css`
                    color: ${themeGet("colors.primary")};
                `}
        `}
    a {
        font-family: 'SF Pro Text';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #6B778C;
        text-decoration: none;
        
        &:hover {
            color: #6B778C;
        }
        ${(props) =>
            props.theme.name === "dark" &&
            css`
                color: ${themeGet("colors.gray600")};
            `}
    }
    &:not(:first-of-type) {
        padding-left: 0.5rem;
        &:before {
            display: inline-block;
            padding-right: 0.5rem;
            color: #6B778C;
            content: "/";
            font-family: 'SF Pro Text';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            ${(props) =>
                props.theme.name === "dark" &&
                css`
                    color: ${themeGet("colors.gray700")};
                    font-weight: 400;
                `}
        }
    }
`;
